import { noteForIndex, triggerMomentary, type InstrumentPlayerProps } from "../playerTypes";

const manuals = [
  { id: "left_thumb_lower_manual", label: "left lower", count: 6 },
  { id: "left_thumb_upper_manual", label: "left upper", count: 6 },
  { id: "right_thumb_lower_three_note_anchor", label: "right anchor", count: 3 },
  { id: "right_thumb_pattern_extension", label: "right lower extension", count: 5 },
  { id: "right_index_upper_response", label: "right index upper", count: 6 }
];

export function MbiraPlayer(props: InstrumentPlayerProps) {
  let tineIndex = 0;

  return (
    <div className="instrument-ui mbira-ui" data-testid="instrument-player-mbira">
      <div className="mbira-board" aria-label="Mbira dzavadzimu non-linear tine manuals" data-control-target="mbira-manuals">
        {manuals.map((manual) => (
          <section key={manual.id} className={`mbira-manual ${manual.id}`} aria-label={manual.label}>
            <strong>{manual.label}</strong>
            <div>
              {Array.from({ length: manual.count }, () => {
                const index = tineIndex;
                tineIndex += 1;
                const noteName = noteForIndex(props.instrument.playableNotes, index);
                return (
                  <button key={index} type="button" className="mbira-tine" aria-label={`Play mbira ${manual.label} tine ${index + 1}`} onClick={() => triggerMomentary(props, noteName, manual.id, 0.64, 620)}>
                    {index + 1}
                  </button>
                );
              })}
            </div>
          </section>
        ))}
      </div>
      <div className="instrument-control-strip">
        <label className="surface-slider" data-control-target="mbira-buzz"><span>Buzz</span><input aria-label="Mbira buzz amount" type="range" min="0" max="1" step="0.01" defaultValue="0.35" onInput={(event) => props.onControl("buzz_amount", Number(event.currentTarget.value))} /></label>
      </div>
      <p className="instrument-note">22-28 tine model with non-linear manuals. The right thumb lower three-note anchor is highlighted.</p>
    </div>
  );
}
